import { i18n } from 'src/i18n';

export const currency = (value: number): string => `${value},- `;

export const currencyWithSuffix = (value: number): string => `${value} ${i18n.currency.suffix}`;

export const currencyWithMonthlySuffix = (value: number): string =>
  `${value} ${i18n.currency.suffix} ${i18n.currency.monthlyPriceSuffix}`;
